import axios from "@/plugins/axios";

let url = "/api/v1/metatags";

export default {
    // get({ params: { path } })
    get(data){
        return axios.get(url, data).then(result => result.data);
    },
}
